(function () {
  "use strict";

  if (window.DeckauraCheckout) return;

  var STORAGE_KEY = "deckaura_checkout_pending_v1";
  var ANALYTICS_SCHEMA = "reading_funnel_v2";
  var RETURN_WINDOW_MS = 30000;
  var RECOVERY_MAX_AGE_MS = 60 * 60 * 1000;
  var NAVIGATION_TIMEOUT_MS = 12000;
  var activeAttempt = null;
  var activePreparation = null;
  var preparationCartReady = false;
  var recoveryCheck = 0;
  var returnedOptions = null;
  var recoveryNode = null;

  var RECOVERY_COPY = {
    en: {
      close: "Close checkout help", eyebrow: "Secure checkout", title: "Your reading is still here",
      browser: "Retry checkout in this browser, or review your cart before continuing. Opening Deckaura in another browser does not transfer this cart.",
      body: "Continue secure checkout in this browser, or review your selected reading in your cart before continuing.",
      retry: "Retry checkout", cart: "Review cart", loading: "Opening secure checkout…",
      error: "Checkout did not open. Please try again or review your cart.",
      existing: "Your cart has a previous selection. Review your cart before changing it.",
      uncertain: "Your cart update could not be confirmed. Review your cart or check again before continuing."
    },
    tr: {
      close: "Ödeme yardımını kapat", eyebrow: "Güvenli ödeme", title: "Yorumunuz burada duruyor",
      browser: "Bu tarayıcıda ödemeyi yeniden deneyin veya devam etmeden önce sepetinizi kontrol edin. Deckaura'yı başka bir tarayıcıda açmak bu sepeti taşımaz.",
      body: "Bu tarayıcıda güvenli ödemeye devam edin veya önce sepetinizdeki seçili yorumu kontrol edin.",
      retry: "Ödemeyi yeniden dene", cart: "Sepeti kontrol et", loading: "Güvenli ödeme açılıyor…",
      error: "Ödeme açılamadı. Yeniden deneyin veya sepetinizi kontrol edin.",
      existing: "Sepetinizde önceki seçiminiz var. Seçimi değiştirmeden önce sepetinizi inceleyin.",
      uncertain: "Sepet güncellemesi doğrulanamadı. Devam etmeden önce sepetinizi inceleyin veya yeniden kontrol edin."
    },
    de: {
      close: "Checkout-Hilfe schließen", eyebrow: "Sicherer Checkout", title: "Deine Deutung ist noch da",
      browser: "Versuche den Checkout in diesem Browser erneut oder prüfe zuerst deinen Warenkorb. Ein anderer Browser übernimmt diesen Warenkorb nicht.",
      body: "Setze den sicheren Checkout in diesem Browser fort oder prüfe zuerst deine gewählte Deutung im Warenkorb.",
      retry: "Checkout erneut versuchen", cart: "Warenkorb prüfen", loading: "Sicherer Checkout wird geöffnet…",
      error: "Der Checkout wurde nicht geöffnet. Versuche es erneut oder prüfe deinen Warenkorb.",
      existing: "Dein Warenkorb enthält eine frühere Auswahl. Prüfe den Warenkorb, bevor du sie änderst.",
      uncertain: "Die Warenkorbänderung konnte nicht bestätigt werden. Prüfe deinen Warenkorb, bevor du fortfährst."
    },
    es: {
      close: "Cerrar la ayuda de pago", eyebrow: "Pago seguro", title: "Tu lectura sigue aquí",
      browser: "Reintenta el pago en este navegador o revisa el carrito antes de continuar. Abrir Deckaura en otro navegador no transfiere este carrito.",
      body: "Continúa con el pago seguro en este navegador o revisa primero la lectura elegida en tu carrito.",
      retry: "Reintentar el pago", cart: "Revisar el carrito", loading: "Abriendo el pago seguro…",
      error: "No se abrió el pago. Inténtalo de nuevo o revisa tu carrito.",
      existing: "Tu carrito contiene una selección anterior. Revísalo antes de cambiarla.",
      uncertain: "No pudimos confirmar la actualización. Revisa el carrito o vuelve a comprobarlo antes de continuar."
    },
    pt: {
      close: "Fechar a ajuda de pagamento", eyebrow: "Pagamento seguro", title: "A sua leitura continua aqui",
      browser: "Tente o pagamento novamente neste navegador ou reveja o carrinho antes de continuar. Abrir a Deckaura noutro navegador não transfere este carrinho.",
      body: "Continue o pagamento seguro neste navegador ou reveja primeiro a leitura escolhida no carrinho.",
      retry: "Tentar o pagamento novamente", cart: "Ver o carrinho", loading: "A abrir o pagamento seguro…",
      error: "O pagamento não abriu. Tente novamente ou reveja o carrinho.",
      existing: "O carrinho contém uma escolha anterior. Reveja o carrinho antes de a alterar.",
      uncertain: "Não foi possível confirmar a alteração. Reveja o carrinho ou verifique novamente antes de continuar."
    }
  };

  function recoveryCopy() {
    var locale = String(
      document.documentElement.lang || (window.Shopify && window.Shopify.locale) || "en"
    ).toLowerCase().split(/[-_]/)[0];
    return RECOVERY_COPY[locale] || RECOVERY_COPY.en;
  }

  function now() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function clean(value, maxLength) {
    return String(value == null ? "" : value)
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, maxLength || 100);
  }

  function shopRoot() {
    var root = "/";
    try {
      root =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        "/";
    } catch (_) {}
    root = String(root || "/");
    if (root.charAt(0) !== "/" || root.slice(0, 2) === "//") root = "/";
    return root.charAt(root.length - 1) === "/" ? root : root + "/";
  }

  function checkoutPath() {
    return shopRoot() + "checkout";
  }

  function isInternalAudit() {
    var flagged = false;
    try {
      var params = new URLSearchParams(window.location.search || "");
      flagged = (
        params.has("funnel_audit") ||
        params.get("internal") === "true" ||
        params.get("traffic_type") === "internal" ||
        params.has("codex_audit") ||
        params.has("deckaura_internal") ||
        params.has("alltools_audit") ||
        /(?:^|\.)localhost$/i.test(window.location.hostname || "")
      );
    } catch (_) {}
    // Match traffic-quality.js when a checkout/return URL loses its QA query.
    try {
      if (flagged) sessionStorage.setItem("deckaura_internal_qa_v1", "1");
      return flagged || sessionStorage.getItem("deckaura_internal_qa_v1") === "1";
    } catch (_) { return flagged; }
  }

  function inAppBrowser() {
    var ua = navigator.userAgent || "";
    if (/\bGSA\/|GoogleApp/i.test(ua)) return "google";
    if (/Instagram/i.test(ua)) return "instagram";
    if (/\bFBAN\/|\bFBAV\/|FB_IAB/i.test(ua)) return "facebook";
    if (/TikTok|musical_ly/i.test(ua)) return "tiktok";
    if (/Line\//i.test(ua)) return "line";
    return "";
  }

  function safeRecord(value) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (_) {}
  }

  function readRecord() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");
    } catch (_) {
      return null;
    }
  }

  function clearRecord() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  }

  function readCurrentCart() {
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 8000) : null;
    var request = { credentials: "same-origin", cache: "no-store", headers: { Accept: "application/json" } };
    if (controller) request.signal = controller.signal;
    return fetch(shopRoot() + "cart.js", request).then(function (response) {
      if (!response.ok) throw new Error("cart_read_http_" + response.status);
      return response.json();
    }).then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) throw new Error("cart_read_invalid");
      return cart;
    }).finally(function () { if (timer) clearTimeout(timer); });
  }

  function itemIdentity(item, upload) {
    var properties = item && item.properties || {};
    if (typeof properties !== "object" || Array.isArray(properties)) throw new Error("cart_item_invalid");
    var sorted = {};
    Object.keys(properties).sort().forEach(function (key) {
      if (upload && upload.fileOperation && properties["_Cart Add Operation"] === upload.fileOperation && upload.fileProperties.indexOf(key) >= 0) return;
      if (properties[key] !== null && properties[key] !== undefined && String(properties[key]) !== "") {
        sorted[key] = String(properties[key]);
      }
    });
    var variant = String(item && (item.variant_id || item.id) || "");
    if (!/^\d+$/.test(variant)) throw new Error("cart_item_invalid");
    var plan = item && (item.selling_plan || item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) || "";
    return JSON.stringify(["deckaura-generic-item-v1", variant, String(plan), sorted]);
  }

  function quantities(items, upload) {
    var totals = Object.create(null);
    if (!window.crypto || !window.crypto.subtle || typeof window.crypto.subtle.digest !== "function" || typeof TextEncoder !== "function") return Promise.reject(new Error("cart_reconciliation_unavailable"));
    return Promise.all((items || []).map(function (item) {
      var quantity = Number(item.quantity == null ? 1 : item.quantity);
      if (!Number.isSafeInteger(quantity) || quantity <= 0) throw new Error("cart_item_invalid");
      return window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(itemIdentity(item, upload))).then(function (digest) {
        var hash = Array.prototype.map.call(new Uint8Array(digest), function (byte) { return byte.toString(16).padStart(2, "0"); }).join("");
        totals[hash] = (totals[hash] || 0) + quantity;
        if (!Number.isSafeInteger(totals[hash])) throw new Error("cart_item_invalid");
      });
    })).then(function () { return totals; });
  }

  function additionState(cart, addition) {
    var requested = addition && addition.requested, baseline = addition && addition.baseline;
    function valid(counts) { return counts && typeof counts === "object" && !Array.isArray(counts) && Object.keys(counts).every(function (key) { return /^[a-f0-9]{64}$/.test(key) && Number.isSafeInteger(counts[key]) && counts[key] > 0; }); }
    if (!valid(requested) || !Object.keys(requested).length || !valid(baseline)) return Promise.reject(new Error("cart_outcome_unknown"));
    if (addition.fileOperation && (!/^[a-f0-9-]{36}$/i.test(addition.fileOperation) || !Array.isArray(addition.fileProperties) || !addition.fileProperties.length || addition.fileProperties.length > 20 || addition.fileProperties.some(function (name) { return typeof name !== "string" || !name || name.length > 100; }))) return Promise.reject(new Error("cart_outcome_unknown"));
    return quantities(cart.items, addition).then(function (actual) {
      return Object.keys(requested).every(function (hash) {
        return actual[hash] === (baseline[hash] || 0) + requested[hash];
      }) ? "confirmed" : "uncertain";
    });
  }

  function sameCounts(first, second) {
    var keys = Object.keys(first).sort();
    return keys.length === Object.keys(second).length && keys.every(function (key) { return first[key] === second[key]; });
  }

  function cartRecovery() {
    var recovery = window.DeckauraReadingCartRecovery;
    if (!recovery || ["withLock", "getPending", "setPending", "clearPending", "reconcilePending"].some(function (method) { return typeof recovery[method] !== "function"; })) throw new Error("cart_reconciliation_unavailable");
    return recovery;
  }

  function hasPendingAddition() {
    try { return !!cartRecovery().getPending(); } catch (_) { return true; }
  }

  function readingItem(item) {
    return !!(item && (item.properties && (item.properties["_Checkout Intent"] || item.properties._checkout_intent || item.properties["_checkout_intent_token"]) || /^READING-(DEEP|MEDIUM|PREMIUM)$/.test(String(item.sku || "").trim().toUpperCase())));
  }

  function readingQuantityCopy() {
    var locale = String(document.documentElement.lang || "en").toLowerCase().replace(/_/g, "-");
    var messages = {
      en: "Each personalized reading must have quantity one. Review your cart and use the correction beside the reading before checkout.",
      tr: "Her kişisel yorumun adedi bir olmalıdır. Ödemeden önce sepeti inceleyin ve yorumun yanındaki düzeltmeyi kullanın.",
      de: "Jede persönliche Deutung muss die Menge eins haben. Prüfe deinen Warenkorb und korrigiere die Menge neben der Deutung vor dem Checkout.",
      fr: "Chaque interprétation personnelle doit avoir une quantité de un. Vérifiez le panier et corrigez la quantité à côté de l’interprétation avant de payer.",
      es: "Cada lectura personalizada debe tener una cantidad de uno. Revisa el carrito y usa la corrección junto a la lectura antes de pagar.",
      "pt-pt": "Cada leitura personalizada deve ter a quantidade de uma unidade. Reveja o carrinho e corrija a quantidade junto à leitura antes de pagar.",
      "pt-br": "Cada leitura personalizada deve ter a quantidade de uma unidade. Revise o carrinho e corrija a quantidade ao lado da leitura antes de pagar."
    };
    return messages[locale] || messages[locale.split("-")[0]] || (/^pt(?:-|$)/.test(locale) ? messages["pt-pt"] : messages.en);
  }

  function checkoutCartPreflight(onReady) {
    return Promise.resolve().then(function () {
      if ((activePreparation && !preparationCartReady) || document.querySelector('[data-cart-add-pending="true"]')) throw new Error("cart_outcome_unknown");
      var recovery = cartRecovery();
      function validate(cart, readOnly) {
        if ((activePreparation && !preparationCartReady) || document.querySelector('[data-cart-add-pending="true"]')) throw new Error("cart_outcome_unknown");
        if (!readOnly && recovery.getPending()) throw new Error("cart_outcome_unknown");
        if (!readOnly && recovery.reconcileRetired) recovery.reconcileRetired(cart,{isReading:readingItem});
        if (cart.items.filter(readingItem).length > 1) throw new Error("reading_cart_conflict");
        if (cart.items.some(function (item) { return readingItem(item) && Number(item.quantity) !== 1; })) throw new Error("reading_quantity_invalid");
        if (typeof onReady === 'function') onReady(cart);
        return cart;
      }
      return withPreparationLock(function () {
        return readCurrentCart().then(function (cart) { return reconcileForNavigation(cart, recovery); }).then(validate);
      }).catch(function (error) {
        // Reading the existing basket does not require writing a safety marker.
        // New additions still fail closed if durable storage is unavailable.
        if (!error || error.message !== "cart_storage_unavailable") throw error;
        return readCurrentCart().then(function (cart) { return validate(cart,true); });
      });
    });
  }

  function afterCheckoutPreflight(attempt, navigate) {
    checkoutCartPreflight(function () {
      if (activeAttempt !== attempt || attempt.confirmed) return;
      navigate();
    }).catch(function (error) {
      if (activeAttempt !== attempt || attempt.confirmed) return;
      if (attempt.timer) clearTimeout(attempt.timer);
      if (normalizeReason(error) === "reading_quantity_invalid") attempt.options.errorMessage = readingQuantityCopy();
      failNavigation(error, "cart_preflight");
    });
  }

  function reconcileForNavigation(cart, recovery) {
    var pending = recovery.getPending();
    if (!pending) return Promise.resolve().then(function () { return recovery.reconcileRetired ? recovery.reconcileRetired(cart,{isReading:readingItem}) : cart; });
    if (pending.kind === 'generic' && /^(prepared|rejected)$/.test(pending.phase || '')) {
      if (!recovery.clearPending(pending)) throw new Error('cart_outcome_unknown');
      return Promise.resolve(cart);
    }
    if (pending.kind === "reading") return Promise.resolve().then(function () { return recovery.reconcilePending(cart, { isReading: readingItem }); }).catch(function (error) {
      if (error && error.message === "reading_cart_conflict" && !recovery.getPending()) return recovery.reconcileRetired ? recovery.reconcileRetired(cart,{isReading:readingItem}) : cart;
      throw error;
    });
    return additionState(cart, pending).then(function (state) {
      if (state !== "confirmed" || !recovery.clearPending(pending)) throw new Error("cart_outcome_unknown");
      return cart;
    });
  }

  function withPreparationLock(task) {
    return Promise.resolve().then(function () { return cartRecovery().withLock(task); });
  }

  function analyticsData(extra) {
    var data = {
      analytics_schema: ANALYTICS_SCHEMA,
      checkout_source: "unknown",
      page_path: window.location.pathname,
      in_app_browser: inAppBrowser() || "none",
      traffic_type: isInternalAudit() ? "internal" : "customer",
    };
    if (extra) {
      Object.keys(extra).forEach(function (key) {
        if (
          [
            "checkout_source",
            "reason",
            "variant_id",
            "reading_type",
            "analytics_schema",
            "funnel_version",
            "funnel_flow_id",
            "status",
            "failure_stage",
            "navigation_method",
            "confirmation_signal",
            "http_status",
          ].indexOf(key) !== -1
        ) {
          data[key] = clean(extra[key], 100);
        }
      });
    }
    return data;
  }

  function track(name, extra) {
    var data = analyticsData(extra);
    try {
      if (typeof window.clarity === "function") {
        window.clarity("set", "analytics_schema", data.analytics_schema);
        window.clarity("set", "traffic_type", data.traffic_type);
        window.clarity("set", "checkout_source", data.checkout_source);
        window.clarity("set", "in_app_browser", data.in_app_browser);
        if (data.funnel_version) window.clarity("set", "funnel_version", data.funnel_version);
        if (data.funnel_flow_id) window.clarity("set", "funnel_flow_id", data.funnel_flow_id);
        if (data.reason) window.clarity("set", "checkout_error_reason", data.reason);
        if (data.failure_stage) window.clarity("set", "checkout_failure_stage", data.failure_stage);
        if (data.navigation_method) window.clarity("set", "checkout_navigation_method", data.navigation_method);
        if (data.confirmation_signal) window.clarity("set", "checkout_confirmation_signal", data.confirmation_signal);
        if (data.http_status) window.clarity("set", "checkout_http_status", data.http_status);
        if (!isInternalAudit()) {
          window.clarity("event", name);
          window.clarity("set", "conversion_stage", name);
        }
      }
    } catch (_) {}
    if (isInternalAudit()) return;
    try {
      if (typeof window.gtag === "function") {
        window.gtag("event", name, data);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(
          Object.assign(
            {
              event: name,
            },
            data,
          ),
        );
      }
    } catch (_) {}
  }

  function normalizeReason(error) {
    if (!error) return "unknown_error";
    if (error.name === "AbortError") return "timeout";
    if (error.name === "TypeError") return "network_error";
    if (error.name === "SyntaxError") return "invalid_json";
    var message = clean(error.message || error, 60).toLowerCase();
    // Keep analytics low-cardinality and prevent server/browser messages from
    // leaking URLs, cart properties, or other user-provided data.
    if (/^[a-z0-9_:-]+$/.test(message)) return message;
    return "unexpected_error";
  }

  function errorElement(options) {
    return options && options.errorElement && options.errorElement.nodeType === 1
      ? options.errorElement
      : null;
  }

  function captureButton(options) {
    var button =
      options && options.trigger && options.trigger.nodeType === 1
        ? options.trigger
        : null;
    if (!button) return null;
    if (!options._originalMarkup) options._originalMarkup = button.innerHTML;
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    if (options.loadingLabel) button.textContent = options.loadingLabel;
    return button;
  }

  function restoreButton(options) {
    var button =
      options && options.trigger && options.trigger.nodeType === 1
        ? options.trigger
        : null;
    if (!button) return;
    button.disabled = false;
    button.removeAttribute("aria-busy");
    if (options._originalMarkup != null) button.innerHTML = options._originalMarkup;
  }

  function setError(options, message) {
    var node = errorElement(options);
    if (!node) return;
    node.textContent = message || "";
    if (message) {
      node.setAttribute("role", "alert");
      node.hidden = false;
    }
  }

  function removeRecovery() {
    if (recoveryNode && recoveryNode.parentNode) {
      recoveryNode.parentNode.removeChild(recoveryNode);
    }
    recoveryNode = null;
  }

  function showRecovery(record, reason, cart) {
    removeRecovery();
    var copy = recoveryCopy();
    var safety = window.DeckauraReadingCartRecovery;
    var extra = safety && safety.recoveryText ? safety.recoveryText(String(document.documentElement.lang || 'en').toLowerCase()) : null;
    var browserName = record && record.in_app_browser;
    var checkoutUrl = new URL(checkoutPath(), window.location.origin).href;
    var wrap = document.createElement("div");
    wrap.className = "deckaura-checkout-recovery";
    wrap.setAttribute("role", "status");
    wrap.setAttribute("aria-live", "polite");
    wrap.setAttribute("aria-labelledby", "deckaura-checkout-recovery-title");
    wrap.innerHTML =
      '<div class="deckaura-checkout-recovery__card">' +
      '<button type="button" class="deckaura-checkout-recovery__close">&times;</button>' +
      '<p class="deckaura-checkout-recovery__eyebrow"></p>' +
      '<h2 id="deckaura-checkout-recovery-title"></h2>' +
      '<p class="deckaura-checkout-recovery__body"></p>' +
      '<div class="deckaura-checkout-recovery__actions">' +
      '<button type="button" class="deckaura-checkout-recovery__retry"></button>' +
      '<a class="deckaura-checkout-recovery__cart"></a>' +
      "</div>" +
      "</div>";

    wrap.querySelector(".deckaura-checkout-recovery__close").setAttribute("aria-label", copy.close);
    wrap.querySelector(".deckaura-checkout-recovery__eyebrow").textContent = copy.eyebrow;
    wrap.querySelector("#deckaura-checkout-recovery-title").textContent = reason === "cart_outcome_unknown" || reason === "cart_existing_selection" ? copy.eyebrow : copy.title;
    wrap.querySelector(".deckaura-checkout-recovery__body").textContent =
      reason === "cart_storage_unavailable" && extra ? extra.storage : reason === "reading_cart_conflict" && extra ? extra.retired : reason === "reading_quantity_invalid" ? readingQuantityCopy() : reason === "cart_outcome_unknown" ? copy.uncertain : reason === "cart_existing_selection" ? copy.existing : (browserName && browserName !== "none" ? copy.browser : copy.body);
    if (reason === "reading_quantity_invalid") wrap.querySelector(".deckaura-checkout-recovery__retry").hidden = true;
    wrap.querySelector(".deckaura-checkout-recovery__retry").textContent = copy.retry;
    wrap.querySelector(".deckaura-checkout-recovery__cart").textContent = copy.cart;

    var style = document.createElement("style");
    style.textContent =
      ".deckaura-checkout-recovery{position:fixed;left:12px;right:12px;bottom:max(12px,env(safe-area-inset-bottom));z-index:2147483000;display:flex;justify-content:center;pointer-events:none}" +
      ".deckaura-checkout-recovery__card{position:relative;width:min(100%,680px);box-sizing:border-box;padding:18px 52px 18px 20px;border:1px solid rgba(212,175,55,.5);border-radius:16px;background:#fffdf8;color:#241a35;box-shadow:0 14px 44px rgba(22,13,38,.24);font:15px/1.45 Arial,sans-serif;pointer-events:auto}" +
      ".deckaura-checkout-recovery__eyebrow{margin:0 0 6px;color:#7b5b18;font-size:12px;font-weight:800;letter-spacing:.12em;text-transform:uppercase}" +
      ".deckaura-checkout-recovery h2{margin:0 0 6px;font:700 21px/1.2 Georgia,serif}" +
      ".deckaura-checkout-recovery p{margin:0 0 12px}" +
      ".deckaura-checkout-recovery__close{position:absolute;right:4px;top:4px;min-width:44px;min-height:44px;border:0;background:transparent;color:#5e5669;font-size:28px;cursor:pointer}" +
      ".deckaura-checkout-recovery__actions{display:flex;flex-wrap:wrap;gap:8px}" +
      ".deckaura-checkout-recovery__actions button,.deckaura-checkout-recovery__actions a{display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;min-height:44px;border-radius:999px;padding:9px 16px;font:inherit;font-weight:800;text-align:center;text-decoration:none;cursor:pointer}" +
      ".deckaura-checkout-recovery__retry{border:1px solid #5a3d8c;background:#5a3d8c;color:#fff}" +
      ".deckaura-checkout-recovery__cart{border:1px solid #c8bed7;background:#fff;color:#35244f}" +
      ".deckaura-checkout-recovery :focus-visible{outline:3px solid #241a35;outline-offset:3px}" +
      "@media(max-width:520px){.deckaura-checkout-recovery{left:8px;right:8px}.deckaura-checkout-recovery__card{padding:16px 42px 14px 16px;max-height:46vh;overflow:auto}.deckaura-checkout-recovery h2{font-size:19px}.deckaura-checkout-recovery__actions{display:grid;grid-template-columns:1fr 1fr}.deckaura-checkout-recovery__actions button,.deckaura-checkout-recovery__actions a{min-width:0;padding:9px 10px;font-size:13px}}";
    wrap.appendChild(style);
    document.body.appendChild(wrap);
    recoveryNode = wrap;
    var pendingReading = null;
    try { pendingReading = safety && safety.getPending(); } catch (_) {}
    if (safety && typeof safety.show === 'function' && (reason === 'reading_cart_conflict' || pendingReading && pendingReading.kind === 'reading')) {
      var readingReview = document.createElement('div');
      readingReview.setAttribute('data-checkout-reading-recovery','');
      wrap.querySelector('.deckaura-checkout-recovery__card').appendChild(readingReview);
      safety.show({host:readingReview,locale:String(document.documentElement.lang || 'en').toLowerCase().replace('pt-br','ptbr').split('-')[0],root:shopRoot(),fetchCart:readCurrentCart,isReading:readingItem,selection:function(){return null;},onResume:function(line){removeRecovery();open(checkoutUrl,{checkoutSource:'saved_reading',variantId:String(line.variant_id||line.id),loadingLabel:copy.loading});}});
    }

    wrap
      .querySelector(".deckaura-checkout-recovery__close")
      .addEventListener("click", removeRecovery);
    wrap
      .querySelector(".deckaura-checkout-recovery__retry")
      .addEventListener("click", function () {
        var retry = wrap.querySelector(".deckaura-checkout-recovery__retry");
        retry.disabled = true;
        retry.setAttribute("aria-busy", "true");
        withPreparationLock(function () {
          var recovery = cartRecovery();
          return readCurrentCart().then(function (current) { return reconcileForNavigation(current, recovery); });
        }).then(function (current) {
          if (!current.items.length) {
            clearRecord();
            removeRecovery();
            return;
          }
          removeRecovery();
          open(checkoutUrl, { checkoutSource: "checkout_recovery", loadingLabel: copy.loading });
        }).catch(function (error) {
          wrap.querySelector(".deckaura-checkout-recovery__body").textContent = error && error.message === 'cart_storage_unavailable' && extra ? extra.storage : hasPendingAddition() ? copy.uncertain : copy.error;
          retry.disabled = false;
          retry.removeAttribute("aria-busy");
        });
      });
    // Ajax carts belong to this browser session. A generic /checkout link
    // cannot transfer the signed reading to another browser.
    wrap.querySelector(".deckaura-checkout-recovery__cart").href =
      shopRoot() + "cart";
    track("checkout_recovery_view", {
      checkout_source: (record && record.checkout_source) || "unknown",
      reason: reason || "returned",
    });
  }

  function confirmNavigation(event) {
    if (
      !activeAttempt ||
      activeAttempt.confirmed ||
      !activeAttempt.navigationRequested
    ) {
      return;
    }
    var attempt = activeAttempt;
    returnedOptions = attempt.options;
    attempt.confirmed = true;
    if (attempt.timer) clearTimeout(attempt.timer);
    var record = attempt.record;
    record.status = "navigated";
    record.navigated_at = now();
    record.navigation_method = attempt.navigationMethod || "unknown";
    safeRecord(record);
    var confirmation = event && event.type ? event.type : "lifecycle";
    track("checkout_navigation_confirmed", {
      checkout_source: record.checkout_source,
      variant_id: record.variant_id,
      reading_type: record.reading_type,
      funnel_version: record.funnel_version,
      funnel_flow_id: record.funnel_flow_id,
      navigation_method: record.navigation_method,
      confirmation_signal: confirmation,
    });
    if (attempt.options.trackCheckoutStart !== false) {
      track("checkout_start", {
        checkout_source: record.checkout_source,
        variant_id: record.variant_id,
        reading_type: record.reading_type,
        funnel_version: record.funnel_version,
        funnel_flow_id: record.funnel_flow_id,
      });
    }
    if (typeof attempt.options.onNavigationConfirmed === "function") {
      try {
        attempt.options.onNavigationConfirmed();
      } catch (_) {}
    }
    track("checkout_redirect_success", {
      checkout_source: record.checkout_source,
      variant_id: record.variant_id,
      reading_type: record.reading_type,
      funnel_version: record.funnel_version,
      funnel_flow_id: record.funnel_flow_id,
      navigation_method: record.navigation_method,
      confirmation_signal: confirmation,
    });
    // pagehide may enter the back/forward cache. Clear the in-memory attempt so
    // a returned visitor can use the recovery CTA without being blocked.
    activeAttempt = null;
  }

  function failNavigation(reason, failureStage) {
    if (!activeAttempt || activeAttempt.confirmed) return;
    var attempt = activeAttempt;
    reason = normalizeReason(reason);
    attempt.record.status = "error";
    attempt.record.reason = reason;
    attempt.record.failure_stage = failureStage || "navigation_confirmation";
    safeRecord(attempt.record);
    track("checkout_redirect_error", {
      checkout_source: attempt.record.checkout_source,
      reason: reason,
      variant_id: attempt.record.variant_id,
      reading_type: attempt.record.reading_type,
      funnel_version: attempt.record.funnel_version,
      funnel_flow_id: attempt.record.funnel_flow_id,
      failure_stage: attempt.record.failure_stage,
      navigation_method: attempt.navigationMethod || "unknown",
    });
    restoreButton(attempt.options);
    setError(
      attempt.options,
      attempt.options.errorMessage ||
        recoveryCopy().error,
    );
    if (typeof attempt.options.onNavigationError === "function") {
      try {
        attempt.options.onNavigationError(reason);
      } catch (_) {}
    }
    showRecovery(attempt.record, reason);
    activeAttempt = null;
  }

  function navigationTimedOut() {
    failNavigation("navigation_timeout", "navigation_confirmation");
  }

  function markNavigationRequested(method) {
    if (!activeAttempt || activeAttempt.confirmed) return false;
    activeAttempt.navigationRequested = true;
    activeAttempt.navigationMethod = clean(method || "unknown", 40);
    activeAttempt.record.status = "navigation_requested";
    activeAttempt.record.navigation_requested_at = now();
    activeAttempt.record.navigation_method = activeAttempt.navigationMethod;
    safeRecord(activeAttempt.record);
    return true;
  }

  function startAttempt(url, options) {
    options = options || {};
    if (activeAttempt && !activeAttempt.confirmed) {
      track("checkout_redirect_error", {
        checkout_source: options.checkoutSource || "unknown",
        reason: "attempt_in_progress",
        failure_stage: "navigation_start",
      });
      return null;
    }

    var target;
    try {
      target = new URL(url || checkoutPath(), window.location.origin);
    } catch (_) {
      target = new URL(checkoutPath(), window.location.origin);
    }

    captureButton(options);
    setError(options, "");
    var record = {
      status: "attempted",
      started_at: now(),
      checkout_url: target.href,
      checkout_source: clean(options.checkoutSource || "unknown", 80),
      page_path: window.location.pathname,
      in_app_browser: inAppBrowser() || "none",
      variant_id: clean(options.variantId || "", 40),
      reading_type: clean(options.readingType || "", 80),
      funnel_version: clean(options.funnelVersion || "", 100),
      funnel_flow_id: clean(options.funnelFlowId || "", 100),
    };
    safeRecord(record);
    track("checkout_redirect_attempt", {
      checkout_source: record.checkout_source,
      variant_id: record.variant_id,
      reading_type: record.reading_type,
    });
    activeAttempt = {
      record: record,
      options: options,
      confirmed: false,
      navigationRequested: false,
      navigationMethod: "unknown",
      timer: setTimeout(
        navigationTimedOut,
        options.navigationTimeoutMs || NAVIGATION_TIMEOUT_MS,
      ),
    };
    return target;
  }

  function open(url, options) {
    var target = startAttempt(url, options || {});
    if (!target) return false;
    var attempt = activeAttempt;
    afterCheckoutPreflight(attempt, function () {
      markNavigationRequested("location_assign");
      window.location.assign(target.href);
    });
    return true;
  }

  function addItemsAndOpen(items, options) {
    options = options || {};
    if (activePreparation || activeAttempt) {
      track("checkout_prepare_blocked", { checkout_source: options.checkoutSource || "unknown", reason: "attempt_in_progress" });
      setError(options, recoveryCopy().uncertain);
      if (typeof options.onError === "function") options.onError("attempt_in_progress", new Error("attempt_in_progress"));
      return Promise.resolve(null);
    }
    if (!Array.isArray(items) || !items.length) {
      var emptyError = new Error("empty_cart_items");
      track("checkout_prepare_error", {
        checkout_source: options.checkoutSource || "unknown",
        reason: "empty_cart_items",
        variant_id: options.variantId || "",
        reading_type: options.readingType || "",
        failure_stage: "cart_validation",
      });
      restoreButton(options);
      setError(
        options,
        options.errorMessage ||
          recoveryCopy().error,
      );
      if (typeof options.onError === "function") {
        options.onError("empty_cart_items", emptyError);
      }
      return Promise.resolve(null);
    }

    captureButton(options);
    setError(options, "");
    track("checkout_prepare_start", {
      checkout_source: options.checkoutSource || "unknown",
      variant_id: options.variantId || "",
      reading_type: options.readingType || "",
    });

    var controller = typeof AbortController === "function" ? new AbortController() : null;
    var timer = null;
    preparationCartReady = false;
    activePreparation = Promise.resolve().then(function () {
      var snapshot = JSON.parse(JSON.stringify(items));
      var upload = options.fileOperation ? { fileOperation: options.fileOperation, fileProperties: options.fileProperties } : null;
      if (upload && (!/^[a-f0-9-]{36}$/i.test(upload.fileOperation) || !Array.isArray(upload.fileProperties) || !upload.fileProperties.length || upload.fileProperties.length > 20 || upload.fileProperties.some(function (name) { return typeof name !== "string" || !name || name.length > 100; }))) throw new Error("cart_item_invalid");
      return quantities(snapshot, upload).then(function (requested) {
        return withPreparationLock(function () {
          var recovery = cartRecovery();
          recovery.getPending();
          return readCurrentCart().then(function (before) {
            var pending = recovery.getPending();
            if (pending && pending.kind === 'generic' && /^(prepared|rejected)$/.test(pending.phase || '')) {
              if (!recovery.clearPending(pending)) throw new Error('cart_outcome_unknown');
              pending = null;
            }
            if (pending && pending.kind === "reading") {
              return Promise.resolve().then(function () { return recovery.reconcilePending(before, { isReading: readingItem }); }).then(function (cart) {
                if (recovery.getPending()) throw new Error("cart_outcome_unknown");
                return prepare(cart);
              });
            }
            if (!pending) { if (recovery.reconcileRetired) recovery.reconcileRetired(before,{isReading:readingItem}); return prepare(before); }
            return additionState(before, pending).then(function (state) {
              if (state !== "confirmed") throw new Error("cart_outcome_unknown");
              if (!sameCounts(requested, pending.requested)) throw new Error("cart_existing_selection");
              if (!recovery.clearPending(pending)) throw new Error("cart_outcome_unknown");
              return { reconciled: true, items: before.items.filter(function (line) { return snapshot.some(function (item) { return itemIdentity(line, pending) === itemIdentity(item, pending); }); }) };
            });

            function prepare(cart) {
              return quantities(cart.items, upload).then(function (baseline) {
                if (window.navigator && window.navigator.onLine === false) throw new Error('network_offline');
                var marker = recovery.setPending(Object.assign({ kind: "generic", phase:'prepared', requested: requested, baseline: baseline, startedAt: now() }, upload || {}));
                var request = {
                  method: "POST",
                  headers: { "Content-Type": "application/json", Accept: "application/json" },
                  credentials: "same-origin",
                  body: JSON.stringify(Object.assign({ items: snapshot }, options.sections ? { sections: options.sections, sections_url: options.sectionsUrl || window.location.pathname } : {}))
                };
                if (options.formData) {
                  var body = new FormData();
                  options.formData.forEach(function (value, name) { body.append(name, value); });
                  if (options.sections) body.set("sections", options.sections.join(","));
                  body.set("sections_url", options.sectionsUrl || window.location.pathname);
                  request.body = body;
                  delete request.headers["Content-Type"];
                }
                if (controller) {
                  request.signal = controller.signal;
                }
                marker = recovery.updatePending(marker,{phase:'add_sent'});
                return recovery.trackMutation(marker,function(){
                  var receivedHeaders = false;
                  var deadline = new Promise(function (_, reject) {
                    timer = setTimeout(function () {
                      var timeoutError = new Error("cart_request_timeout");
                      timeoutError.checkoutStage = receivedHeaders ? "cart_add_parse" : "cart_add_request";
                      reject(timeoutError);
                      if (controller) controller.abort();
                    }, options.cartTimeoutMs || 12000);
                  });
                  var result = Promise.resolve().then(function () { return fetch(shopRoot() + "cart/add.js", request); }).then(function (response) {
                    receivedHeaders = true;
                    if (!response.ok) {
                      if (response.status >= 400 && response.status < 500 && !recovery.clearPending(marker)) throw new Error("cart_outcome_unknown");
                      var httpError = new Error("cart_add_http_" + response.status);
                      httpError.checkoutStage = "cart_add_response";
                      httpError.httpStatus = response.status;
                      throw httpError;
                    }
                    return response.json().catch(function (error) { error.checkoutStage = "cart_add_parse"; throw error; });
                  });
                  return Promise.race([result,deadline]).finally(function () { if (timer) clearTimeout(timer); });
                }).then(function (payload) {
                  if (!payload) {
                    var payloadError = new Error("cart_add_empty_response");
                    payloadError.checkoutStage = "cart_add_parse";
                    throw payloadError;
                  }
                  return readCurrentCart().then(function (fresh) {
                    return additionState(fresh, marker).then(function (state) {
                      if (state !== "confirmed" || !recovery.clearPending(marker)) throw new Error("cart_outcome_unknown");
                      return payload;
                    });
                  });
                }).catch(function(error){if(error && error.message === 'network_offline') recovery.clearPending(marker);throw error;});
              });
            }
          });
        });
      });
    }).then(function (payload) {
        preparationCartReady = true;
        track("checkout_cart_ready", {
          checkout_source: options.checkoutSource || "unknown",
          variant_id: options.variantId || "",
          reading_type: options.readingType || "",
        });
        if (typeof options.onCartSuccess === "function") {
          try {
            options.onCartSuccess(payload);
          } catch (_) {}
        }
        if (options.openCheckout !== false && !open(options.checkoutUrl || checkoutPath(), options)) {
          var navigationError = new Error("navigation_start_rejected");
          navigationError.checkoutStage = "navigation_start";
          throw navigationError;
        }
        return payload;
      })
      .catch(function (error) {
        if (timer) clearTimeout(timer);
        var reason = normalizeReason(error);
        var failureStage =
          clean(error && error.checkoutStage, 40) || "cart_add_request";
        track("checkout_prepare_error", {
          checkout_source: options.checkoutSource || "unknown",
          reason: reason,
          variant_id: options.variantId || "",
          reading_type: options.readingType || "",
          funnel_version: options.funnelVersion || "",
          funnel_flow_id: options.funnelFlowId || "",
          failure_stage: failureStage,
          http_status: error && error.httpStatus ? error.httpStatus : "",
        });
        restoreButton(options);
        var pending = hasPendingAddition();
        var safetyApi = window.DeckauraReadingCartRecovery;
        var safetyText = safetyApi && safetyApi.recoveryText ? safetyApi.recoveryText(String(document.documentElement.lang||'en').toLowerCase()) : null;
        setError(options, reason === 'cart_storage_unavailable' && safetyText ? safetyText.storage : reason === "cart_existing_selection" ? recoveryCopy().existing : pending ? recoveryCopy().uncertain : (options.errorMessage || recoveryCopy().error));
        if (pending) showRecovery({ checkout_source: options.checkoutSource || "unknown" }, reason === 'cart_storage_unavailable' || reason === "cart_existing_selection" ? reason : "cart_outcome_unknown");
        if (typeof options.onError === "function") {
          try {
            options.onError(reason, error);
          } catch (_) {}
        }
        return null;
      }).finally(function () {
        if (timer) clearTimeout(timer);
        if (options.openCheckout === false) restoreButton(options);
        preparationCartReady = false;
        activePreparation = null;
      });
    return activePreparation;
  }

  function detectReturnedCheckout() {
    var record = readRecord();
    if (!record || (record.status !== "navigated" && record.status !== "returned")) return;
    if (record.page_path && record.page_path !== window.location.pathname) {
      clearRecord();
      return;
    }
    var elapsed = now() - Number(record.navigated_at || record.started_at || 0);
    if (elapsed < 0 || elapsed > RECOVERY_MAX_AGE_MS) {
      clearRecord();
      return;
    }
    var firstReturn = record.status !== "returned";
    record.status = "returned";
    record.returned_at = now();
    safeRecord(record);
    if (firstReturn) track(elapsed <= RETURN_WINDOW_MS ? "checkout_returned_under_30s" : "checkout_returned", {
      checkout_source: record.checkout_source,
      reason: record.in_app_browser !== "none" ? "in_app_return" : "early_return",
      variant_id: record.variant_id,
      reading_type: record.reading_type,
    });
    var check = ++recoveryCheck;
    readCurrentCart().then(function (cart) {
      if (check !== recoveryCheck || activeAttempt) return;
      if (hasPendingAddition()) { showRecovery(record, "cart_outcome_unknown", cart); return; }
      if (!cart.items.length) { clearRecord(); removeRecovery(); return; }
      showRecovery(record, elapsed <= RETURN_WINDOW_MS ? "early_return" : "returned", cart);
    }).catch(function () {
      track("checkout_recovery_check_failed", { checkout_source: record.checkout_source, reason: "cart_read_failed" });
    });
  }

  window.addEventListener("pagehide", confirmNavigation);
  window.addEventListener("pageshow", function () {
    if (returnedOptions) {
      restoreButton(returnedOptions);
      returnedOptions = null;
    }
    window.setTimeout(detectReturnedCheckout, 0);
  });

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || form.nodeName !== "FORM") return;
      var submitter = event.submitter || document.activeElement;
      var isCheckout =
        submitter &&
        submitter.getAttribute &&
        submitter.getAttribute("name") === "checkout";
      if (!isCheckout) return;
      if (event.defaultPrevented) return;
      var nativeAttempt = startAttempt(checkoutPath(), {
        checkoutSource: form.id || "cart_form",
        trigger: submitter,
        loadingLabel: recoveryCopy().loading,
        navigationTimeoutMs: 15000,
      });
      event.preventDefault();
      if (!nativeAttempt) return;
      var attempt = activeAttempt;
      afterCheckoutPreflight(attempt, function () {
      if (submitter.name) {
        var hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = submitter.name;
        hidden.value = submitter.value || "";
        form.appendChild(hidden);
      }
        markNavigationRequested("native_form_submit");
        HTMLFormElement.prototype.submit.call(form);
      });
    },
    true,
  );

  document.addEventListener(
    "click",
    function (event) {
      var link =
        event.target && event.target.closest
          ? event.target.closest('a[href*="/checkout"]')
          : null;
      if (!link) return;
      event.preventDefault();
      if (activeAttempt) return;
      open(link.href, {
        checkoutSource: "checkout_link",
        trigger: link,
        loadingLabel: recoveryCopy().loading,
      });
    },
    true,
  );

  window.DeckauraCheckout = {
    open: open,
    addItemsAndOpen: addItemsAndOpen,
    addItems: function (items, options) { return addItemsAndOpen(items, Object.assign({}, options || {}, { openCheckout: false })); },
    detectInAppBrowser: inAppBrowser,
    dismissRecovery: function () {
      recoveryCheck++;
      removeRecovery();
    },
    showRecovery: function () {
      return readCurrentCart().then(function (cart) {
        if (cart.items.length) showRecovery(readRecord() || {}, "manual", cart);
      }).catch(function () { return null; });
    },
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", detectReturnedCheckout, {
      once: true,
    });
  } else {
    detectReturnedCheckout();
  }
})();
